
import React, { useState } from 'react';
import { IoMdClose } from "react-icons/io";

import { useGlobalState } from '../../../global_state_components/GlobalStateProvider.jsx';
import styles from './sessionClickedOverlayForSilentStudy.module.css';
import {useAuth} from '../../../global_state_components/AuthProvider.jsx';
import { axiosInstance } from '../../../../lib/axiosInstance.js';
import CircularProgress from '@mui/material/CircularProgress';


function SessionClickedOverlayForSilentStudy(){
  const {isMobile, bookedPersonArray, isSilentStudyBookingDone, setIsSilentStudyBookingDone, bookWithFriendsButtonRef, clickedGridTimeInDayHourMinute, subject, heightOfCalendarGrid, setShowStrangersList, setShowFriendsList} = useGlobalState();
  const {isAuthenticated} = useAuth();

  const [isStrangersBookingDone, setIsStrangersBookingDone] = useState(false);  // State to track if the booking is done
  const [mode, setMode] = useState('Public');
  const [strangersBookingLoading, setStrangersBookingLoading] = useState(false); // State to track loading



  async function handleBookingWithStrangers(){

    //console.log("sessionClickedOverlayForSilentStudy is authenticated : "+isAuthenticated);
    if (isAuthenticated==='authenticated') {

      //Book with the person who has booked that slot.
      setStrangersBookingLoading(true); // Set loading to true for the specific button
      try {

        if(bookedPersonArray.length >= 1){    //There should only be 1 person in the bookedPersonArray or nil.
          const response = await axiosInstance.post('/sessions/requests',  {"sessionId": bookedPersonArray[0]._id});   
          setIsStrangersBookingDone(true); // Set booking status to true for the specific button
          //console.log("response of handleBookingWithStrangers function : "+JSON.stringify(response.data, null, 2));

        }else{  // If there is no person then create a session.

          const session = {
            "subject": "",
            "topic": "",
            "day": clickedGridTimeInDayHourMinute["dayNumber"],
            "month": clickedGridTimeInDayHourMinute["month"],            //This needs to be changed. It should be the booked day's month in the grid. It need not be today's month.     // If you need leading zero, use 'MM' instead
            "year": clickedGridTimeInDayHourMinute["year"],          //This needs to be changed. It should be the booked day's month in the grid. It need not be today's month.
            "hour": clickedGridTimeInDayHourMinute["hour"],
            "minutes": clickedGridTimeInDayHourMinute["minute"],
            "mode": mode,
            "type":"Silent study with partner",                     //category
            "requestFriends":[]
          }

          /*
          console.log("z : "+clickedGridTimeInDayHourMinute["day"]);
          console.log("x : "+clickedGridTimeInDayHourMinute["hour"]);
          console.log("c : "+clickedGridTimeInDayHourMinute["minute"]);
          console.log("v : "+clickedGridTimeInDayHourMinute["month"]);
          console.log("b : "+clickedGridTimeInDayHourMinute["year"]);
          */

          //console.log("session : "+JSON.stringify(session, null, 2));

          const response = await axiosInstance.post('/sessions',  session);   
          setIsStrangersBookingDone(true);
          setIsSilentStudyBookingDone(true);
          //console.log("response of handleAutomaticBooking function : "+JSON.stringify(response.data, null, 2));
           
        }

      } catch (error) {
        //console.log("Error in handleDirectAndRequestBook function : "+error);
        if (error.response) {
          // Server responded with a status other than 200 range
          console.log("Error Data: ", error.response.data);
          console.log("Error Status: ", error.response.status);
          console.log("Error Headers: ", error.response.headers);
        } else if (error.request) {
          // Request was made but no response was received
          console.log("Error Request: ", error.request);
        } else {
          // Something else happened
          console.log("Error Message: ", error.message);
        }
      } finally {
        setStrangersBookingLoading(false); // Set loading to false for the specific button
      }

    } else {
      // Optional: Add some alert or feedback if not authenticated
      alert("You need to login to book.");
    }

  };




  const handleBookingWithFriends = () => {
    //console.log("sessionClickedOverlayForDiscussAndLearn is authenticated : "+isAuthenticated);
    if (isAuthenticated==='authenticated') {
      setShowFriendsList(prev => !prev);
    } else {
      // Optional: Add some alert or feedback if not authenticated
      alert("You need to login to book.");
    }
  }

  //---------{props.bookedPeopleSessionsList.map(function (item, index){   Like this how it is in StrangerList has to be done here. 

  return(
    <div className={styles.clicked_overlay} style={{height : `${6*heightOfCalendarGrid+3}px`}}>
      <button onClick={handleBookingWithStrangers} className={styles.slot_book_any_button}> 
        {strangersBookingLoading ? <CircularProgress size={24} /> : (isStrangersBookingDone ? 'Booked' : 'Book')}
      </button>
      <button onClick={handleBookingWithFriends} ref={bookWithFriendsButtonRef} className={styles.slot_book_friend_button}> 
        Book with a friend
      </button>
      {/*<IoMdClose onClick={()=>setShowFriendsList(false)} className={styles.close_icon}/>*/}
    </div>
  );
}

export default SessionClickedOverlayForSilentStudy;

